export type BoosterType =
	"FULL_INSTALLATION_QUOTE"
	| "FINANCE_BY_HIBER"
	| "LEADS_GENERATION_BY_HIBER"
	| "CALL_ANSWERING_SERVICE"
	| "GET_A_FREE_TABLET"
	| "CONNECT_TO_XERO_OR_QUICK_BOOKS"
	| "BOOKKEEPING_BY_HIBER"

export type BoostersMap = { [booster in BoosterType]: boolean };

export const BoostersLabel: { [booster in BoosterType]: string } = {
	FULL_INSTALLATION_QUOTE: "Full Installation Quote",
	FINANCE_BY_HIBER: "Finance by hiber",
	LEADS_GENERATION_BY_HIBER: "Lead generation by hiber",
	CALL_ANSWERING_SERVICE: "Call answering service",
	GET_A_FREE_TABLET: "Get a free tablet",
	CONNECT_TO_XERO_OR_QUICK_BOOKS: "Connect to Xero / QuickBooks",
	BOOKKEEPING_BY_HIBER: "Bookkeeping by hiber"
}
